

<template>
	<compWrapper :title="query?'提货信息':'联系方式'" theme="primary">
		<vTableSimple
			v-if="query"
			class="margin-10"
			:columns="columns"
			:data="formList"
			size="small"
			border
			stripe
		></vTableSimple>
		<template v-else>
			<compFormEdit
				v-for="(formData,index) in formList"
				class="margin-right-15"
				:key="index"
				:formdata="getBase"
				v-model="formList[index]"
				ref="form"
			></compFormEdit>
		</template>
		<footer v-if="!review" class="clearfix">
			<vButton theme="info" class="margin-10 pull-left width-15per" @click="add" icon="md-add">添加提货信息</vButton>
			<vButton theme="success" class="margin-10 pull-right width-15per" @click="nextStep">提交预览</vButton>
			<vButton theme="primary" class="margin-10 pull-right width-15per" @click="preStep">上一步</vButton>
		</footer>
	</compWrapper>
</template>

<script>
import { HttpShipOBillList, HttpShipOBillDataList } from '@/service/boss/shipment'
import { HttpAllotAddress } from '@/service/boss/dictionary'
export default {
	props: ['data', 'type', 'status', 'parentId'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
	},
	data() {
		return {
			formList: [
				{
					factoryEmail: '',
					factoryTelephone: '',
					factoryContactName: '',
					factoryName: '',
					shipperName: '',
					shipperContactName: '',
					shipperTelephone: '',
					shipperEmail: '',
				}
			]
		}
	},
	created() {
		if (this.data.length > 0) this.formList = [...this.data];
	},
	computed: {
		query() {
			return this.review || this.type === 'query'
		},
		review() {
			return this.status === 'review'
		},
		getBase() {
			const query = this.review;
			return [{
				valueText: "<div class=detail-title>工厂联系方式</div>",
				query: true,
				span: 24,
				labelWidth: 0
			}, {
				label: '工厂名称',
				key: 'factoryName',
				query,
			}, {
				label: '电话',
				key: 'factoryTelephone',
				query,
			}, {
				label: '联系人',
				key: 'factoryContactName',
				query,
			}, {
				label: '邮箱',
				key: 'factoryEmail',
				required: false,
				query,
			}, {
				valueText: "<div class=detail-title>发货方联系方式</div>",
				query: true,
				span: 24,
				labelWidth: 0
			}, {
				label: '发货方公司名称',
				key: 'shipperName',
				query,
			}, {
				label: '电话',
				key: 'shipperTelephone',
				required: true,
				query,
			}, {
				label: '联系人',
				key: 'shipperContactName',
				query,
			}, {
				label: '邮箱',
				key: 'shipperEmail',
				required: false,
				query,
			}]
		},
		columns() {
			return [{
				title: '发货方名称',
				key: 'shipperName',
			}, {
				title: '发货方联系方式',
				key: 'shipperContactName',
				render(h, { row }) {
					return <div>
						<div>联系人:{row.shipperContactName}</div>
						<div>电话:{row.shipperTelephone}</div>
						<div>邮箱:{row.shipperEmail}</div>
					</div>
				}
			}, {
				title: '工厂名称',
				key: 'factoryName',
			}, {
				title: '工厂联系方式',
				key: 'factoryContactName',
				render(h, { row }) {
					return <div>
						<div>联系人:{row.factoryContactName}</div>
						<div>电话:{row.factoryTelephone}</div>
						<div>邮箱:{row.factoryEmail}</div>
					</div>
				}
			},]
		},
	},
	methods: {
		nextStep() {
			const promises = this.$refs.form.map(async (ref) => {
				const valid = await ref.validate();
				return valid ? Promise.resolve(true) : Promise.reject(false);
			});
			Promise.all(promises).then(posts => {
				const parent = this.$parent;
				parent.addressData = this.formList;
				parent.status = 'review';
			}).catch(err => {

			})
		},
		preStep() {
			this.$parent.getDetail().then(res => {
				this.$parent.status = 'bill';
			})
		},
		async add() {
			this.formList.push({
				factoryEmail: '',
				factoryTelephone: '',
				factoryContactName: '',
				factoryName: '',
				shipperName: '',
				shipperContactName: '',
				shipperTelephone: '',
				shipperEmail: '',
			});
		}
	},

}
</script>

